import React from "react";

export interface selectorItem {
    label?: string,
    description?: string,
    value: any,
    key: string
    prefixElement?: React.ReactNode;
}
export const Colors = {
    red: 'red',
    orange: 'orange',
    yellow: 'yellow',
    green: 'green',
    default: 'darkGrey',
    auto: 'auto',
    lightYellow: 'lightYellow',
    grey:'grey',
    darkGrey: 'darkGrey',
    purple: 'purple',
    blue: 'blue',
    pink: 'pink',
    graphite: 'graphite',
    disabled: 'disabled',

} as const;

export type ColorKey = keyof typeof Colors;

enum MessageType {
    WELCOME_MESSAGE = "WELCOME_MESSAGE",
    MENU_MESSAGE = "MENU_MESSAGE",
    AFTER_HOURS_MESSAGE = "AFTER_HOURS_MESSAGE",
    WORKING_HOURS_WELCOME_MESSAGE = "WORKING_HOURS_WELCOME_MESSAGE",
    PLAY_MESSAGE = "PLAY_MESSAGE",
}
export enum ButtonType {
    primary = "primary",
    secondary = "secondary",
    destructive = "destructive",
    destructiveSecondary = "destructiveSecondary",
    textDestructiveSecondary = "textDestructiveSecondary",
    textPrimary = "textPrimary",
    textSecondary = "textSecondary",
    textError = "textError",

}
export enum IconType {
    primary = "primary",
    secondary = "secondary",
    destructive = "destructive",
    destructiveSecondary = "destructiveSecondary",
    textDestructiveSecondary = "textDestructiveSecondary",
    textPrimary = "textPrimary",
    textSecondary = "textSecondary",


}
const getPlayMessageType = (index: number): string => `PLAY_MESSAGE_${index}`;

export { MessageType, getPlayMessageType };